import { Breadcrumb } from 'antd';
import React from 'react';

/** A single breadcrumb segment with an optional navigation target. */
export interface BreadcrumbItem {
  title: string;
  /** When present, clicking navigates to this path via the app router. */
  href?: string;
}

/** Props for the `AppBreadcrumb` component. */
interface AppBreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (path: string) => void;
}

/** Ant Design breadcrumb that intercepts `<a>` clicks and delegates to the SPA `onNavigate` handler instead of following hrefs. */
export const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ items, onNavigate }) => (
  <Breadcrumb
    className="app-breadcrumb"
    items={items.map((item) => {
      const href = item.href;
      return {
        title: href ? (
          <a
            href={href}
            onClick={(e) => {
              e.preventDefault();
              onNavigate(href);
            }}
          >
            {item.title}
          </a>
        ) : (
          item.title
        ),
      };
    })}
  />
);

export default AppBreadcrumb;
